export default "__VITE_ASSET__D$hpVMGY__"